import person from '@/api/person'
import macademic from '@/api/macademic'
import {
  ARTICLE_STATUS,
  REVIEWER_STATUS,
  ACADEMIC_STATUS,
  DECISION_STATUS
} from '@/utils/dict'
import help from '../../../../utils/help'
const SUBMITED = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Submitted Time',
    width: 150,
    dataIndex: 'firstSubmitTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Updated Time',
    width: 150,
    dataIndex: 'statusTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 200,
    dataIndex: 'status',
    slot: 'status'
  }
]
const REPORTS = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Invited Time',
    width: 150,
    dataIndex: 'invitedTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Spend Day(s)',
    width: 200,
    dataIndex: 'statusTime',
    slot: 'spend'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 150,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Decision',
    width: 200,
    dataIndex: 'decisionStatus',
    slot: 'decision'
  },
  {
    title: '',
    enTitle: 'Review Rating',
    width: 150,
    dataIndex: 'rating',
    slot: 'rating'
  }
]
const DECISION = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Invited Time',
    width: 150,
    dataIndex: 'invitedTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 150,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Decision',
    width: 200,
    dataIndex: 'decisionStatus',
    slot: 'decision'
  },
  {
    title: '',
    enTitle: 'Spend Day(s)',
    width: 200,
    dataIndex: 'statusTime',
    slot: 'spend'
  }
]
export default {
  props: {
    roleType: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      id: '',
      articalStatus: ARTICLE_STATUS,
      reviewerStatus: REVIEWER_STATUS,
      decisionStatus: DECISION_STATUS,
      academicStatus: ACADEMIC_STATUS,
      titleIndex: 'SUBMITED',
      titleTab: {
        SUBMITED: 'Submissions',
        REPORTS: 'Reports',
        DECISION: 'Decisions'
      },
      dataSource: [],
      params: {
        invitedTimeStart: this.$moment().subtract(60, 'days'),
        invitedTimeEnd: this.$moment()
      },
      isActive: 'day',
      columns: {
        SUBMITED: SUBMITED,
        REPORTS: REPORTS,
        DECISION: DECISION
      },
      rating: {
        EXCELLENT: 'Excellent',
        GOOD: 'Good',
        AVERAGE: 'Average',
        POOR: 'Poor'
      }
    }
  },
  mounted() {
    this.id = this.$route.params.id
    let title = this.$route.query.title
    if (title) {
      this.titleIndex = title
    }
    this.getList()
  },
  methods: {
    changeTitle(val) {
      this.titleIndex = val
      this.getList()
    },
    async getList() {
      let list = []
      let data = {}
      switch (this.titleIndex) {
        case 'SUBMITED':
          list = await person.submit(this.id)
          break
        case 'REPORTS':
          data = Object.assign(this.params, { stateList: 'COMPLETED' })
          list = await person.rmanuscript(this.id, data)
          break
        case 'DECISION':
          data = Object.assign(this.params, {
            stateList: 'PRE_CHECK_DONE,FIRST_DECISION_DONE,FINAL_DECISION_DONE'
          })
          list = await macademic.personRecord(this.id, data)
          break
      }
      this.dataSource = list
    },
    searchList(key) {
      this.isActive = key
      if (key === 'day') {
        this.params.invitedTimeStart = this.$moment().subtract(60, 'days')
        this.params.invitedTimeEnd = this.$moment()
      } else {
        this.params.invitedTimeStart = null
        this.params.invitedTimeEnd = null
      }
      this.getList()
    },
    linkTo(item) {
      help.openWindow(
        `/academic-menu/academic/detail/${item.decisionType}/${item.id}?manuscriptId=${item.manuscriptId}&sign=${item.sign}&status=${item.status}`
      )
    }
  }
}
